import { z } from 'zod';

// Organisation validation schemas
export const createOrganisationSchema = z.object({
  name: z.string().min(1, 'Organisation name is required'),
  billingEmail: z.string().email('Valid email is required'),
  planId: z.string().min(1, 'Plan ID is required'),
  tierLevel: z.number().int().min(1).max(4, 'Tier level must be between 1 and 4').default(1),
  enabled: z.boolean().optional(),
  contactName: z.string().optional(),
  contactEmail: z.string().email().optional(),
  address: z
    .object({
      street: z.string(),
      city: z.string(),
      postalCode: z.string(),
      country: z.string(),
    })
    .optional(),
});

export const updateOrganisationSchema = z.object({
  name: z.string().min(1).optional(),
  billingEmail: z.string().email().optional(),
  planId: z.string().min(1).optional(),
  tierLevel: z.number().int().min(1).max(4).optional(),
  enabled: z.boolean().optional(),
  contactName: z.string().optional(),
  contactEmail: z.string().email().optional(),
  address: z
    .object({
      street: z.string(),
      city: z.string(),
      postalCode: z.string(),
      country: z.string(),
    })
    .optional(),
});

// Type exports derived from schemas
export type CreateOrganisationRequest = z.infer<typeof createOrganisationSchema>;
export type UpdateOrganisationRequest = z.infer<typeof updateOrganisationSchema>;
